import React, { useState } from "react";

export default function TopUpWalletModal({ show, onClose }) {
  const [amount, setAmount] = useState("");
  const [loading, setLoading] = useState(false);

  const conversionRate = 1000; // ₦1000 = 1 unit
  const units = amount ? (parseFloat(amount) / conversionRate).toFixed(2) : "0.00";

  const handleTopUp = () => {
    if (!amount || parseFloat(amount) < conversionRate) {
      alert("Please enter a valid amount (minimum ₦1000).");
      return;
    }

    setLoading(true);

    setTimeout(() => {
      setLoading(false);
      alert(`Wallet topped up with ₦${amount}! You received ${units} units.`);
      setAmount("");
      onClose();
    }, 2000); // simulate API call
  };

  return (
    <div
      className={`modal fade ${show ? "show d-block" : ""}`}
      tabIndex="-1"
      style={{ background: show ? "rgba(0,0,0,0.5)" : "transparent" }}
    >
      <div className="modal-dialog modal-lg modal-dialog-centered">
        <div className="modal-content">
          {/* 🔵 Modal Header */}
          <div className="modal-header">
            <h5 className="modal-title fw-bold">Top Up Wallet</h5>
            <button className="btn-close" onClick={onClose}></button>
          </div>

          {/* 🔵 Modal Body */}
          <div className="modal-body">
            {/* ✅ Conversion Rate */}
            <div className="text-center mb-4">
              <h4 className="fw-bold greeting-text">₦1000 = 1 Unit</h4>
              <p className="text-muted small">
                Add funds to your wallet to receive units. Units are required for guest check-ins.
              </p>
            </div>

            {/* ✅ Amount Input */}
            <div className="mb-4">
              <label className="form-label fw-bold">Enter Amount (₦)</label>
              <input
                type="number"
                className="form-control form-control-lg"
                placeholder="e.g. 5000"
                value={amount}
                onChange={(e) => setAmount(e.target.value)}
                min="1000"
              />
            </div>

            {/* ✅ Units Display */}
            <div className="text-center mb-4">
              <h5 className="fw-bold">You will receive:</h5>
              <h2 className="fw-bold text-success">{units} Units</h2>
            </div>
          </div>

          {/* 🔵 Modal Footer */}
          <div className="modal-footer">
            <button className="btn btn-secondary" onClick={onClose}>
              Cancel
            </button>
            <button
              className="btn btn-primary"
              onClick={handleTopUp}
              disabled={!amount || loading}
            >
              {loading ? (
                <>
                  <span
                    className="spinner-border spinner-border-sm me-2"
                    role="status"
                  ></span>
                  Processing...
                </>
              ) : (
                `Top Up Wallet`
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
